import { createSlice } from '@reduxjs/toolkit'

const classDetailsStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: classDetailsStatus.LOADING,
    classDetails: {
        objectives: [],
    },
    errorMessage: null,
    relatedClasses: [],
}

const classDetailsSlice = createSlice({
    name: 'classDetails',
    initialState,
    reducers: {
        getClassDetailsRequest: state => {
            state.status = classDetailsStatus.LOADING
        },
        getClassDetailsRequestSuccess: (state, action) => {
            state.status = classDetailsStatus.SUCCESS
            const { class: classObj, relatedClasses } = action.payload
            classObj.objectives = classObj.objectives.split(';')
            state.classDetails = classObj
            state.relatedClasses = relatedClasses
        },
        getClassDetailsRequestError: (state, action) => {
            state.status = classDetailsStatus.FAILURE
            state.errorMessage = action.payload
        },
        reset: state => initialState,
    },
})

const {
    getClassDetailsRequest,
    getClassDetailsRequestSuccess,
    getClassDetailsRequestError,
    reset,
} = classDetailsSlice.actions

export const classDetailsActions = {
    getClassDetailsRequest,
    getClassDetailsRequestSuccess,
    getClassDetailsRequestError,
    reset,
}

export const classDetailsSelectors = {
    isFetching: state =>
        state.classDetails.status === classDetailsStatus.LOADING,
    hasError: state => state.classDetails.status === classDetailsStatus.FAILURE,
    errorMessage: state => state.classDetails.errorMessage,
    classDetails: state => state.classDetails.classDetails,
    relatedClasses: state => state.classDetails.relatedClasses,
}

const classDetailsReducer = classDetailsSlice.reducer

export default classDetailsReducer
